/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/js/util/dom.js
// This is not really a perfect check, but works fine.
// From http://stackoverflow.com/questions/384286
const HAS_DOM_2 = typeof HTMLElement === "object";
const HAS_SHADOW = typeof ShadowRoot !== "undefined";

/**
 * Determines whether an object is a DOM element or not.
 * @param {!Object} obj Object to check
 * @return {boolean} True if object is an element
 */
function isDOMElement(obj) {
  if (HAS_SHADOW && obj instanceof ShadowRoot) {
    return true;
  }
  return HAS_DOM_2
    ? obj instanceof HTMLElement
    : obj &&
        typeof obj === "object" &&
        obj !== null &&
        obj.nodeType === 1 &&
        typeof obj.nodeName === "string";
}

/**
 * Adds an array of classes to an element
 * @param {!Element} el Element to add classes to
 * @param {!Array<!string>} classNames Class names to add
 * @return {void}
 */
function addClasses(el, classNames) {
  classNames.forEach(function(className) {
    el.classList.add(className);
  });
}

/**
 * Removes an array of classes from an element
 * @param {!Element} el Element to remove classes from
 * @param {!Array<!string>} classNames Classes to remove
 * @return {void}
 */
function removeClasses(el, classNames) {
  classNames.forEach(function(className) {
    el.classList.remove(className);
  });
}

// CONCATENATED MODULE: ./src/js/injectBaseStylesheet.js
/* UNMINIFIED RULES

@keyframes lum-noop {
  0% { zoom: 1; }
}

.lum-lightbox {
  position: fixed;
  display: none;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.lum-lightbox.lum-open {
  display: block;
}

.lum-lightbox.lum-opening, .lum-lightbox.lum-closing {
  animation: lum-noop 1ms;
}

.lum-lightbox-inner {
  position: absolute;
  top: 0%;
  right: 0%;
  bottom: 0%;
  left: 0%;

  overflow: hidden;
}

.lum-lightbox-loader {
  display: none;
}

.lum-lightbox-inner img {
  max-width: 100%;
  max-height: 100%;
}

.lum-lightbox-image-wrapper {
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}
*/

const RULES = `@keyframes lum-noop{0%{zoom:1}}.lum-lightbox{position:fixed;display:none;top:0;right:0;bottom:0;left:0}.lum-lightbox.lum-open{display:block}.lum-lightbox.lum-closing,.lum-lightbox.lum-opening{animation:lum-noop 1ms}.lum-lightbox-inner{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden}.lum-lightbox-loader{display:none}.lum-lightbox-inner img{max-width:100%;max-height:100%}.lum-lightbox-image-wrapper{vertical-align:middle;display:table-cell;text-align:center}`;

/**
 * Injects the base stylesheet needed to display the lightbox
 * element.
 * If `node` is the document, the stylesheet will be appended to `<head>`.
 * @param {!Node} node Node to append stylesheet to
 * @return {void}
 */
function injectBaseStylesheet(node) {
  if (!node || node === document) {
    node = document.head;
  }

  if (node.querySelector(".lum-base-styles")) {
    return;
  }

  const styleEl = document.createElement("style");
  styleEl.type = "text/css";
  styleEl.classList.add("lum-base-styles");

  styleEl.appendChild(document.createTextNode(RULES));

  node.insertBefore(styleEl, node.firstChild);
}

// CONCATENATED MODULE: ./src/js/util/throwIfMissing.js
/**
 * Throws a missing parameter error
 */
function throwIfMissing() {
  throw new Error("Missing parameter");
}

// CONCATENATED MODULE: ./src/js/Lightbox.js



const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;

// All officially-supported browsers have this, but it's easy to
// account for, just in case.
const HAS_ANIMATION =
  typeof document === "undefined"
    ? false
    : "animation" in document.createElement("div").style;

/**
 * Represents the default lightbox implementation
 */
class Lightbox_Lightbox {
  /**
   * Constructor
   * @param {Object=} options Lightbox options
   */
  constructor(options = {}) {
    this._sizeImgWrapperEl = this._sizeImgWrapperEl.bind(this);
    this.showNext = this.showNext.bind(this);
    this.showPrevious = this.showPrevious.bind(this);
    this._completeOpen = this._completeOpen.bind(this);
    this._completeClose = this._completeClose.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleClose = this._handleClose.bind(this);

    const {
      namespace = null,
      parentEl = throwIfMissing(),
      triggerEl = throwIfMissing(),
      sourceAttribute = throwIfMissing(),
      caption = null,
      includeImgixJSClass = false,
      _gallery = null,
      _arrowNavigation = null,
      closeButtonEnabled = true,
      closeTrigger = "click"
    } = options;

    this.settings = {
      namespace,
      parentEl,
      triggerEl,
      sourceAttribute,
      caption,
      includeImgixJSClass,
      _gallery,
      _arrowNavigation,
      closeButtonEnabled,
      onClose: options.onClose,
      closeTrigger
    };

    if (!isDOMElement(this.settings.parentEl)) {
      throw new TypeError(
        "`new Lightbox` requires a DOM element passed as `parentEl`."
      );
    }

    this.currentTrigger = this.settings.triggerEl;

    this.openClasses = this._buildClasses("open");
    this.openingClasses = this._buildClasses("opening");
    this.closingClasses = this._buildClasses("closing");

    this.hasBeenLoaded = false;
    this.elementBuilt = false;
  }

  /**
   * Handles closing of the lightbox
   * @param {!Event} e Event that triggered closing
   * @return {void}
   * @protected
   */
  _handleClose(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    const onClose = this.settings.onClose;
    if (onClose && typeof onClose === "function") {
      onClose();
    }
  }

  /**
   * Binds event listeners to the trigger element
   * @return {void}
   * @protected
   */
  _bindEventListeners() {
    this.el.addEventListener(this.settings.closeTrigger, this._handleClose);
    if (this.closeButtonEl) {
      this.closeButtonEl.addEventListener("click", this._handleClose);
    }
  }

  /**
   * Builds a class list using the namespace and suffix, if any.
   * @param {string} suffix Suffix to add to each class
   * @return {!Array<!string>} Class list
   * @protected
   */
  _buildClasses(suffix) {
    const classes = [`lum-${suffix}`];

    const ns = this.settings.namespace;
    if (ns) {
      classes.push(`${ns}-${suffix}`);
    }

    return classes;
  }

  /**
   * Creates the lightbox element
   * @return {void}
   * @protected
   */
  _buildElement() {
    this.el = document.createElement("div");
    addClasses(this.el, this._buildClasses("lightbox"));

    this.innerEl = document.createElement("div");
    addClasses(this.innerEl, this._buildClasses("lightbox-inner"));
    this.el.appendChild(this.innerEl);

    const loaderEl = document.createElement("div");
    addClasses(loaderEl, this._buildClasses("lightbox-loader"));
    this.innerEl.appendChild(loaderEl);

    this.imgWrapperEl = document.createElement("div");
    addClasses(this.imgWrapperEl, this._buildClasses("lightbox-image-wrapper"));
    this.innerEl.appendChild(this.imgWrapperEl);

    const positionHelperEl = document.createElement("span");
    addClasses(
      positionHelperEl,
      this._buildClasses("lightbox-position-helper")
    );
    this.imgWrapperEl.appendChild(positionHelperEl);

    this.imgEl = document.createElement("img");
    addClasses(this.imgEl, this._buildClasses("img"));
    positionHelperEl.appendChild(this.imgEl);

    this.captionEl = document.createElement("p");
    addClasses(this.captionEl, this._buildClasses("lightbox-caption"));
    positionHelperEl.appendChild(this.captionEl);

    if (this.settings.closeButtonEnabled) {
      this.closeButtonEl = document.createElement("div");
      addClasses(this.closeButtonEl, this._buildClasses("close-button"));
      this.el.appendChild(this.closeButtonEl);
    }

    if (this.settings._gallery) {
      this._setUpGalleryElements();
    }

    this.settings.parentEl.appendChild(this.el);

    this._updateImgSrc();
    this._updateCaption();

    if (this.settings.includeImgixJSClass) {
      this.imgEl.classList.add("imgix-fluid");
    }
  }

  /**
   * Creates gallery elements such as previous/next buttons
   * @return {void}
   * @protected
   */
  _setUpGalleryElements() {
    this._buildGalleryButton("previous", this.showPrevious);
    this._buildGalleryButton("next", this.showNext);
  }

  /**
   * Creates a gallery button
   * @param {string} name Name of button
   * @param {!Function} fn Click handler
   * @return {void}
   * @protected
   */
  _buildGalleryButton(name, fn) {
    const btn = document.createElement("button");
    this[`${name}Button`] = btn;

    btn.innerText = name;
    addClasses(btn, this._buildClasses(`${name}-button`));
    addClasses(btn, this._buildClasses("gallery-button"));
    this.innerEl.appendChild(btn);

    btn.addEventListener(
      "click",
      e => {
        e.stopPropagation();

        fn();
      },
      false
    );
  }

  /**
   * Sizes the image wrapper
   * @return {void}
   * @protected
   */
  _sizeImgWrapperEl() {
    const style = this.imgWrapperEl.style;
    style.width = `${this.innerEl.clientWidth}px`;
    style.maxWidth = `${this.innerEl.clientWidth}px`;
    style.height = `${this.innerEl.clientHeight -
      this.captionEl.clientHeight}px`;
    style.maxHeight = `${this.innerEl.clientHeight -
      this.captionEl.clientHeight}px`;
  }

  /**
   * Updates caption from settings
   * @return {void}
   * @protected
   */
  _updateCaption() {
    const captionType = typeof this.settings.caption;
    let caption = "";

    if (captionType === "string") {
      caption = this.settings.caption;
    } else if (captionType === "function") {
      caption = this.settings.caption(this.currentTrigger);
    }

    this.captionEl.innerHTML = caption;
  }

  /**
   * Updates image element from the trigger element's attributes
   * @return {void}
   * @protected
   */
  _updateImgSrc() {
    const imageURL = this.currentTrigger.getAttribute(
      this.settings.sourceAttribute
    );

    if (!imageURL) {
      throw new Error(
        `No image URL was found in the ${
          this.settings.sourceAttribute
        } attribute of the trigger.`
      );
    }

    const loadingClasses = this._buildClasses("loading");

    if (!this.hasBeenLoaded) {
      addClasses(this.el, loadingClasses);
    }

    this.imgEl.onload = () => {
      removeClasses(this.el, loadingClasses);
      this.hasBeenLoaded = true;
    };

    this.imgEl.setAttribute("src", imageURL);
  }

  /**
   * Handles key up/down events for moving between items
   * @param {!Event} e Keyboard event
   * @return {void}
   * @protected
   */
  _handleKeydown(e) {
    if (e.keyCode == LEFT_ARROW) {
      this.showPrevious();
    } else if (e.keyCode == RIGHT_ARROW) {
      this.showNext();
    }
  }

  /**
   * Shows the next item if in a gallery
   * @return {void}
   */
  showNext() {
    if (!this.settings._gallery) {
      return;
    }

    this.currentTrigger = this.settings._gallery.nextTrigger(
      this.currentTrigger
    );
    this._updateImgSrc();
    this._updateCaption();
    this._sizeImgWrapperEl();
  }

  /**
   * Shows the previous item if in a gallery
   * @return {void}
   */
  showPrevious() {
    if (!this.settings._gallery) {
      return;
    }

    this.currentTrigger = this.settings._gallery.previousTrigger(
      this.currentTrigger
    );
    this._updateImgSrc();
    this._updateCaption();
    this._sizeImgWrapperEl();
  }

  /**
   * Opens the lightbox
   * @return {void}
   */
  open() {
    if (!this.elementBuilt) {
      this._buildElement();
      this._bindEventListeners();
      this.elementBuilt = true;
    }

    // When opening, always reset to the trigger we were passed
    this.currentTrigger = this.settings.triggerEl;

    // Make sure to re-set the `img` `src`, in case it's been changed
    // by someone/something else.
    this._updateImgSrc();
    this._updateCaption();

    addClasses(this.el, this.openClasses);

    this._sizeImgWrapperEl();
    window.addEventListener("resize", this._sizeImgWrapperEl, false);

    if (this.settings._arrowNavigation) {
      window.addEventListener("keydown", this._handleKeydown, false);
    }

    if (HAS_ANIMATION) {
      this.el.addEventListener("animationend", this._completeOpen, false);
      addClasses(this.el, this.openingClasses);
    }
  }

  /**
   * Closes the lightbox
   * @return {void}
   */
  close() {
    window.removeEventListener("resize", this._sizeImgWrapperEl, false);

    if (this.settings._arrowNavigation) {
      window.removeEventListener("keydown", this._handleKeydown, false);
    }

    if (HAS_ANIMATION) {
      this.el.addEventListener("animationend", this._completeClose, false);
      addClasses(this.el, this.closingClasses);
    } else {
      removeClasses(this.el, this.openClasses);
    }
  }

  /**
   * Handles animations on completion of opening the lightbox
   * @return {void}
   * @protected
   */
  _completeOpen() {
    this.el.removeEventListener("animationend", this._completeOpen, false);

    removeClasses(this.el, this.openingClasses);
  }

  /**
   * Handles animations on completion of closing the lightbox
   * @return {void}
   * @protected
   */
  _completeClose() {
    this.el.removeEventListener("animationend", this._completeClose, false);

    removeClasses(this.el, this.openClasses);
    removeClasses(this.el, this.closingClasses);
  }

  /**
   * Destroys the lightbox
   * @return {void}
   */
  destroy() {
    if (this.el) {
      this.settings.parentEl.removeChild(this.el);
    }
  }
}

// CONCATENATED MODULE: ./src/js/Luminous.js




/**
 * Represents the default luminous lightbox
 */
class Luminous_Luminous {
  /**
   * Constructor
   * @param {!Element} trigger Trigger element to open lightbox
   * @param {Object=} options Luminous options
   */
  constructor(trigger, options = {}) {
    this.VERSION = "2.3.4";
    this.destroy = this.destroy.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this._handleKeyup = this._handleKeyup.bind(this);

    this.isOpen = false;

    this.trigger = trigger;

    if (!isDOMElement(this.trigger)) {
      throw new TypeError(
        "`new Luminous` requires a DOM element as its first argument."
      );
    }

    let rootNode = document;
    if ("getRootNode" in this.trigger) {
      rootNode = this.trigger.getRootNode();
    }
    // Prefix for generated element class names (e.g. `my-ns` will
    // result in classes such as `my-ns-lightbox`. Default `lum-`
    // prefixed classes will always be added as well.
    const namespace = options["namespace"] || null;
    // Which attribute to pull the lightbox image source from.
    const sourceAttribute = options["sourceAttribute"] || "href";
    // Captions can be a literal string, or a function that receives the Luminous instance's trigger element as an argument and returns a string. Supports HTML, so use caution when dealing with user input.
    const caption = options["caption"] || null;
    // The event to listen to on the _trigger_ element: triggers opening.
    const openTrigger = options["openTrigger"] || "click";
    // The event to listen to on the _lightbox_ element: triggers closing.
    const closeTrigger = options["closeTrigger"] || "click";
    // Allow closing by pressing escape.
    const closeWithEscape = "closeWithEscape" in options ? !!options["closeWithEscape"] : true;
    // Automatically close when the page is scrolled.
    const closeOnScroll = options["closeOnScroll"] || false;
    const closeButtonEnabled =
      options["showCloseButton"] != null ? options["showCloseButton"] : true;
    const appendToNode =
      options["appendToNode"] ||
      (rootNode === document ? document.body : rootNode);
    // A selector defining what to append the lightbox element to.
    const appendToSelector = options["appendToSelector"] || null;
    // If present (and a function), this will be called
    // whenever the lightbox is opened.
    const onOpen = options["onOpen"] || null;
    // If present (and a function), this will be called
    // whenever the lightbox is closed.
    const onClose = options["onClose"] || null;
    // When true, adds the `imgix-fluid` class to the `img`
    // inside the lightbox. See https://github.com/imgix/imgix.js
    // for more information.
    const includeImgixJSClass = options["includeImgixJSClass"] || false;
    // Add base styles to the page. See the "Theming"
    // section of README.md for more information.
    const injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true;
    // Internal use only!
    const _gallery = options["_gallery"] || null;
    const _arrowNavigation = options["_arrowNavigation"] || null;

    this.settings = {
      namespace,
      sourceAttribute,
      caption,
      openTrigger,
      closeTrigger,
      closeWithEscape,
      closeOnScroll,
      closeButtonEnabled,
      appendToNode,
      appendToSelector,
      onOpen,
      onClose,
      includeImgixJSClass,
      injectBaseStyles,
      _gallery,
      _arrowNavigation
    };

    let injectionRoot = document.body;
    if (appendToNode && "getRootNode" in appendToNode) {
      injectionRoot = appendToNode.getRootNode();
    }

    if (this.settings.injectBaseStyles) {
      injectBaseStylesheet(injectionRoot);
    }

    this._buildLightbox();
    this._bindEventListeners();
  }

  /**
   * Opens the lightbox
   * @param {Event=} e Event which triggered opening
   * @return {void}
   */
  open(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    this.lightbox.open();

    if (this.settings.closeOnScroll) {
      window.addEventListener("scroll", this.close, false);
    }

    const onOpen = this.settings.onOpen;
    if (onOpen && typeof onOpen === "function") {
      onOpen();
    }

    this.isOpen = true;
  }

  /**
   * Closes the lightbox
   * @param {Event=} e Event which triggered closing
   * @return {void}
   */
  close(e) {
    if (this.settings.closeOnScroll) {
      window.removeEventListener("scroll", this.close, false);
    }

    this.lightbox.close();

    const onClose = this.settings.onClose;
    if (onClose && typeof onClose === "function") {
      onClose();
    }

    this.isOpen = false;
  }

  /**
   * Builds the internal lightbox instance
   * @protected
   * @return {void}
   */
  _buildLightbox() {
    let parentEl = this.settings.appendToNode;

    if (this.settings.appendToSelector) {
      parentEl = document.querySelector(this.settings.appendToSelector);
    }

    this.lightbox = new Lightbox_Lightbox({
      namespace: this.settings.namespace,
      parentEl: parentEl,
      triggerEl: this.trigger,
      sourceAttribute: this.settings.sourceAttribute,
      caption: this.settings.caption,
      includeImgixJSClass: this.settings.includeImgixJSClass,
      closeButtonEnabled: this.settings.closeButtonEnabled,
      _gallery: this.settings._gallery,
      _arrowNavigation: this.settings._arrowNavigation,
      closeTrigger: this.settings.closeTrigger,
      onClose: this.close
    });
  }

  /**
   * Binds lightbox events to the trigger element
   * @protected
   * @return {void}
   */
  _bindEventListeners() {
    this.trigger.addEventListener(this.settings.openTrigger, this.open, false);

    if (this.settings.closeWithEscape) {
      window.addEventListener("keyup", this._handleKeyup, false);
    }
  }

  /**
   * Unbinds all events
   * @protected
   * @return {void}
   */
  _unbindEvents() {
    this.trigger.removeEventListener(
      this.settings.openTrigger,
      this.open,
      false
    );
    if (this.lightbox.el) {
      this.lightbox.el.removeEventListener(
        this.settings.closeTrigger,
        this.close,
        false
      );
    }

    if (this.settings.closeWithEscape) {
      window.removeEventListener("keyup", this._handleKeyup, false);
    }
  }

  /**
   * Handles key up events and closes lightbox when esc is pressed
   * @param {!Event} e Keyboard event
   * @return {void}
   * @protected
   */
  _handleKeyup(e) {
    if (this.isOpen && e.keyCode === 27) {
      this.close();
    }
  }

  /**
   * Destroys internal lightbox and unbinds events
   * @return {void}
   */
  destroy() {
    this._unbindEvents();
    this.lightbox.destroy();
  }
}

/* eslint-disable no-self-assign */
Luminous_Luminous.prototype["open"] = Luminous_Luminous.prototype.open;
Luminous_Luminous.prototype["close"] = Luminous_Luminous.prototype.close;
Luminous_Luminous.prototype["destroy"] = Luminous_Luminous.prototype.destroy;
/* eslint-enable no-self-assign */

// CONCATENATED MODULE: ./src/js/LuminousGallery.js


/**
 * Represents a gallery-style lightbox
 */
class LuminousGallery_LuminousGallery {
  /**
   * Constructor
   * @param {!Array<!Element>} triggers Array of trigger elements
   * @param {Object=} options Gallery options
   * @param {Object=} luminousOpts Luminous options
   */
  constructor(triggers, options = {}, luminousOpts = {}) {
    const optionsDefaults = {
      arrowNavigation: true
    };

    this.settings = Object.assign({}, optionsDefaults, options);

    this.triggers = triggers;
    this.luminousOpts = luminousOpts;
    this.luminousOpts["_gallery"] = this;
    this.luminousOpts["_arrowNavigation"] = this.settings["arrowNavigation"];
    this._constructLuminousInstances();
  }

  /**
   * Creates internal luminous instances
   * @protected
   * @return {void}
   */
  _constructLuminousInstances() {
    this.luminousInstances = [];

    const triggerLen = this.triggers.length;
    for (let i = 0; i < triggerLen; i++) {
      const trigger = this.triggers[i];
      const lum = new Luminous_Luminous(trigger, this.luminousOpts);
      this.luminousInstances.push(lum);
    }
  }

  /**
   * Determines the next trigger element
   * @param {!Element} trigger Current trigger element
   * @return {!Element}
   */
  nextTrigger(trigger) {
    const nextTriggerIndex =
      Array.prototype.indexOf.call(this.triggers, trigger) + 1;

    return nextTriggerIndex >= this.triggers.length
      ? this.triggers[0]
      : this.triggers[nextTriggerIndex];
  }

  /**
   * Determines the previous trigger element
   * @param {!Element} trigger Current trigger element
   * @return {!Element}
   */
  previousTrigger(trigger) {
    const prevTriggerIndex =
      Array.prototype.indexOf.call(this.triggers, trigger) - 1;

    return prevTriggerIndex < 0
      ? this.triggers[this.triggers.length - 1]
      : this.triggers[prevTriggerIndex];
  }

  /**
   * Destroys the internal luminous instances
   * @return {void}
   */
  destroy() {
    this.luminousInstances.forEach(instance => instance.destroy());
  }
}

/* eslint-disable-next-line no-self-assign */
LuminousGallery_LuminousGallery.prototype["destroy"] = LuminousGallery_LuminousGallery.prototype.destroy;

// CONCATENATED MODULE: ./src/js/lum-browser.js
// This file is used for the standalone browser build




window["LuminousGallery"] = LuminousGallery_LuminousGallery;
window["Luminous"] = Luminous_Luminous;


/***/ })
/******/ ]);